import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const ProgressChart = ({weeklyData}) => {
const weeklyData_ = [
{ week: 'Week 1', applications: 12, matches: 8, interviews: 2 },
{ week: 'Week 2', applications: 18, matches: 14, interviews: 4 },
{ week: 'Week 3', applications: 15, matches: 11, interviews: 3 },
{ week: 'Week 4', applications: 22, matches: 16, interviews: 6 },
{ week: 'This Week', applications: 8, matches: 6, interviews: 1 }
];

const CustomTooltip = ({ active, payload, label }) => {
if (active && payload && payload?.length) {
return (
<div className="bg-popover border border-border rounded-lg p-3 shadow-elevation-2">
<p className="font-medium text-text-primary mb-2">{label}</p>
{payload?.map((entry, index) => (
<p key={index} className="text-sm" style={{ color: entry?.color }}>
{entry?.name}: {entry?.value}
</p>
))}
</div>
);
}
return null;
};

return (
<div className="bg-card border border-border rounded-lg p-4 sm:p-5 md:p-6">

{/* Header */}
<div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">

<h3 className="text-base sm:text-lg font-semibold text-text-primary">
Weekly Progress
</h3>

<div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-xs sm:text-sm">

<div className="flex items-center gap-2">
<div className="w-3 h-3 bg-primary rounded-full"></div>
<span className="text-text-secondary">Applications</span>
</div>

<div className="flex items-center gap-2">
<div className="w-3 h-3 bg-success rounded-full"></div>
<span className="text-text-secondary">Matches</span>
</div>

<div className="flex items-center gap-2">
<div className="w-3 h-3 bg-warning rounded-full"></div>
<span className="text-text-secondary">Interviews</span>
</div>

</div>
</div>

{/* Chart */}
<div
className="w-full h-56 sm:h-64"
aria-label="Weekly Application Progress Chart"
>

<ResponsiveContainer width="100%" height="100%">
<BarChart
data={weeklyData}
margin={{ top: 10, right: 10, left: -10, bottom: 0 }}
>

<CartesianGrid
strokeDasharray="3 3"
stroke="var(--color-border)"
/>

<XAxis
dataKey="week"
stroke="var(--color-text-secondary)"
fontSize={11}
/>

<YAxis
stroke="var(--color-text-secondary)"
fontSize={11}
/>

<Tooltip content={<CustomTooltip />} />

<Bar
dataKey="applications"
fill="var(--color-primary)"
name="Applications"
radius={[3, 3, 0, 0]}
/>

<Bar
dataKey="matches"
fill="var(--color-success)"
name="Matches"
radius={[3, 3, 0, 0]}
/>

<Bar
dataKey="interviews"
fill="var(--color-warning)"
name="Interviews"
radius={[3, 3, 0, 0]}
/>

</BarChart>
</ResponsiveContainer>

</div>

</div>
);
};

export default ProgressChart;